import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const PlusIcon = (props: IconProps) => (
  <Icon viewBox="0 0 16 16" fill="none" title={t`Plus`} {...props}>
    <Path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M8 12V4M12 8H4"
    />
  </Icon>
);
